<template>
  <div id="app" class="container-fluid">
    <div v-if="loading" class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <div v-if="errored">
      <b-alert variant="danger" show>{{ error_message }}</b-alert>
    </div>
    <!-- welcome -->
    <div id="welcome" v-if="current_step < 0">
      <div>
        <p class="h1">Teste dein Bewusstsein!</p>
        <p>Beantworte X einfache Fragen und bekomme so einen Vorgeschmack auf die 8awareness Bewusstseinsanalyse!</p>
        <b-button @click="load_survey()">Los!</b-button>
        <br>
        <img alt="8awareness logo" src="./assets/8_logo.svg">
        <img alt="brainpunks logo" src="./assets/brainpunks_logo.png">
      </div>
    </div>
    <!-- -->
    <div id="survey" v-else-if="current_step >= 0 && current_step < questions.length">
      <b-card>
        <b-card-header>
          <b-progress :max="questions.length" height="2rem">
            <b-progress-bar :value="current_step + 1">
              <strong>{{ current_step + 1 }} / {{ questions.length }}</strong>
            </b-progress-bar>
          </b-progress>
        </b-card-header>
        <b-card-body>
          <p class="h1">{{ questions[current_step].title }}</p>
          <b-button @click="answer_array[current_step] = -2; current_step += 1">Find ich richtig doof</b-button>
          <b-button @click="answer_array[current_step] = -1; current_step += 1">Find ich blöd</b-button>
          <b-button @click="answer_array[current_step] = 0; current_step += 1">Neutral egal</b-button>
          <b-button @click="answer_array[current_step] = 1; current_step += 1">Find ich gut</b-button>
          <b-button @click="answer_array[current_step] = 2; current_step += 1">Find ich richtig geil</b-button>

        </b-card-body>
        <b-card-footer>
          <b-button v-if="current_step > 0" @click="current_step -= 1">Zurück</b-button>
        </b-card-footer>
      </b-card>
    </div>
    <div id="form" v-else-if="current_step === questions.length">
      <b-form @submit="on_form_submit">
        <div class="form-row">
          <div class="col-md-4 mb-3">
            <b-form-group id="input-group-given-name" label="Dein Vorname:" label-for="input-given-name">
          <b-form-input
            id="input-given-name"
            v-model="form.given_name"
            placeholder="Vorname eingeben"
            required
          ></b-form-input>
        </b-form-group>
          </div>
          <div class="col-md-4 mb-3">
            <b-form-group id="input-group-family-name" label="Dein Nachname:" label-for="input-family-name">
              <b-form-input
                id="input-family-name"
                v-model="form.family_name"
                placeholder="Nachname eingeben"
                required
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 mb-3">
            <b-form-group id="input-group-gender" label="Dein Geschlecht:" label-for="input-gender">
              <b-form-select v-model="form.gender" :options="gender_options">
              </b-form-select>
            </b-form-group>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-12 mb-3">
            <b-form-group
              id="input-group-email"
              label="Email Addresse:"
              label-for="input-email"
              description="Deine Adresse wird nicht mit dritten geteilt!"
            >
              <b-form-input
                id="input-email"
                v-model="form.email"
                type="email"
                placeholder="Mailadresse eingeben"
                required
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-4 mb-3">
            <b-form-checkbox
          id="input-eula"
          v-model="form.eula"
          name="input-eula"
          required>
          Ich stimme der weitergabe von meinen Daten zu!
        </b-form-checkbox>
          </div>
          <div class="col-md-4 mb-3">
            <b-form-checkbox
          id="input-policy"
          v-model="form.policy"
          name="input-policy"
          >
          Datenschutz, weiss ich Bescheid!
        </b-form-checkbox>
                  <b-form-invalid-feedback>
        Your user ID must be 5-12 characters long.
      </b-form-invalid-feedback>
          </div>
          <div class="col-md-4 mb-3">
            <b-form-checkbox
          id="input-ads"
          v-model="form.ads"
          name="input-ads"
          >
          Werbung ist richtig toll!
        </b-form-checkbox>
          </div>
        </div>

        <b-button type="submit" variant="primary">Kostenlos Vorabauswertung erhalten!</b-button>
      </b-form>
    </div>
    <div id="end" v-else>
      <p class="h1"> Danke für fertig sein!</p>
      <p>Was soll passieren?</p>
      <p>{{ evaluation }}</p>
    </div>
    <div>
      <p>Datenschutz und Impressum und EULA?</p>
      <p>Support Konktakt alles ein Link?</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

import {
  BAlert, BButton, BProgress, BProgressBar, BCard, BCardBody, BCardFooter, BCardHeader,
  BForm, BFormGroup, BFormInput, BFormCheckbox, BFormSelect, BFormInvalidFeedback
} from "bootstrap-vue";

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  name: 'App',
  props: {
    api_url: {
      type: String,
      default: "http://localhost:8000/brainpunks/shortsurvey"
    },
    api_key: {
      type: String,
      default: "0000"
    },
  },
  data: () => ({
    persona: null,
    evaluation: null,
    error_message: "",
    loading: false,
    errored: false,
    answer_array: [0, ],
    current_step: -1,
    questions: [{title: 'Frage1'}, ],
    form: {
      given_name: '',
      family_name: '',
      email: '',
      eula: false,
      policy: false,
      ads: false,
      gender: 1,
    },
    gender_options: [
      { value: 1, text: 'weiblich' },
      { value: 2, text: 'männlich' },
      { value: 3, text: 'besonders' },
    ]
  }),
  components: {
    BAlert,
    BButton,
    BProgress,
    BProgressBar,
    BCardFooter,
    BCardHeader,
    BCardBody,
    BCard,
    BForm, BFormGroup, BFormInput, BFormCheckbox, BFormSelect, BFormInvalidFeedback
  },
  methods: {
    on_form_submit: function (event) {
      event.preventDefault()
      this.loading = true
      const params = {
          email: this.form.email,
          given_name: this.form.given_name,
          family_name: this.form.family_name,
          gender: this.form.gender,
          is_eula: this.form.eula,
          is_ads: this.form.ads,
          is_policy: this.form.policy,
          survey_results: this.answer_array
        }
      const post_url = this.api_url + '/' + this.api_key + '/submit'
      console.log(post_url)
      axios.post(post_url, params)
        .then(response => {
          // advance to end screen
          console.log(response.data)
          this.persona = response.data.persona
          this.evaluation = response.data.evaluation
          this.current_step += 1
        })
        .catch(error => {
          this.errored = true
          this.error_message = 'Oh nein! Ein Fehler: ' + error
        })
        .finally(() => (this.loading = false))
    },
    load_survey: function () {
      this.loading = true
      axios.get(this.api_url + '/' + this.api_key + '/questions')
        .then(response => {
          this.questions = response.data.map(title => ({ title }));
          this.answer_array = Array(this.questions.length).fill(0)
          this.current_step += 1
        })
        .catch(error => {
          this.errored = true
          this.error_message = 'Oh nein! Ein Fehler:  ' + error
        })
        .finally(() => (this.loading = false))
    },
  }
}
</script>

<style lang="scss">

@import "./../node_modules/bootstrap/dist/css/bootstrap.css";
@import "./../node_modules/bootstrap-vue/dist/bootstrap-vue.css";

</style>